// extracted by css-extract-rspack-plugin
export default {"StyledAnchor":"DashCardActionButton-module__StyledAnchor___Dp_oZ"};